module.exports = __webpack_public_path__ + "static/img/section_shape.96bf2fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/section_shape.png
// module id = vW4+
// module chunks = 0